export default "__VITE_ASSET__CenIl1hN__"